import { render, staticRenderFns } from "./DeliveryArchive.vue?vue&type=template&id=643b5802&scoped=true"
import script from "./DeliveryArchive.vue?vue&type=script&lang=js"
export * from "./DeliveryArchive.vue?vue&type=script&lang=js"
import style0 from "./DeliveryArchive.vue?vue&type=style&index=0&id=643b5802&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b5802",
  null
  
)

export default component.exports